import LoggerState from 'app/enums/LoggerState'

export default function(input){

    switch(input){

        case LoggerState.AVAILABLE: return 'positive';
        case LoggerState.DEPLOYED: return 'warning';
        case LoggerState.RETURNING: return 'notice';
        case LoggerState.REPAIR_PENDING: return 'grey';
        case LoggerState.REPAIR_ACTIVE: return 'highlight-2';
        case LoggerState.WRITTEN_OF: return 'negative';
        default: return '';
    }
}